import React from "react";
import { Checkbox } from "@material-ui/core/";

export default (
    itensTableSelected,
    countModal,
    handlerClickCheckbox
) => {
    return (
        <div align="center">
            <Checkbox
                edge="start"
                tabIndex={-1}
                disableRipple
                checked={(itensTableSelected.length == countModal) && (countModal != 0)}
                onClick={handlerClickCheckbox}
            />
        </div>
    );
};